let googleApiKey = "AIzaSyAqbgIl4URfXytllls3ClUdeJFs60CS8AI"
let geocodeApiKey = "AIzaSyCk8nmG8utQ9dg7YofQe8ITjqWUsSD3FFI"
module.exports = {
  googleApiKey: googleApiKey,
  geocodeApiKey: geocodeApiKey
}
